import React from 'react'
import { Container, Typography, Stack, Paper, useTheme } from '@mui/material'
import { Navbar } from '../features/navigation/components/Navbar'
import { Footer } from '../features/footer/Footer'

export const TermsOfUsePage = () => {
  const theme = useTheme()

  return (
    <Stack minHeight="100vh" sx={{ display: 'flex', flexDirection: 'column' }}>
      <Navbar />
      <Container maxWidth="md" sx={{ flex: 1, py: 4 }}>
        <Paper elevation={3} sx={{ p: 4, backgroundColor: theme.palette.background.paper }}>
          <Typography variant="h3" sx={{ mb: 3, fontWeight: 'bold', color: theme.palette.primary.main }}>
            Terms of Use
          </Typography>

          <Stack spacing={3}>
            <Paper elevation={0} sx={{ p: 2, backgroundColor: theme.palette.grey[50] }}>
              <Typography variant="h5" sx={{ mb: 1, fontWeight: 'bold' }}>
                1. Acceptance of Terms
              </Typography>
              <Typography>
                By accessing and using NEXO Shop, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
              </Typography>
            </Paper>

            <Paper elevation={0} sx={{ p: 2, backgroundColor: theme.palette.grey[50] }}>
              <Typography variant="h5" sx={{ mb: 1, fontWeight: 'bold' }}>
                2. Use License
              </Typography>
              <Typography>
                Permission is granted to temporarily download one copy of the materials for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
              </Typography>
              <Typography component="div" sx={{ ml: 2, mt: 1 }}>
                • Modifying or copying the materials<br />
                • Using the materials for any commercial purpose or any public display<br />
                • Attempting to decompile or reverse engineer any software<br />
                • Transmitting or storing illegal content<br />
                • Disrupting the normal flow of dialogue within our website
              </Typography>
            </Paper>

            <Paper elevation={0} sx={{ p: 2, backgroundColor: theme.palette.grey[50] }}>
              <Typography variant="h5" sx={{ mb: 1, fontWeight: 'bold' }}>
                3. Disclaimer
              </Typography>
              <Typography>
                The materials on NEXO Shop are provided on an "as is" basis. NEXO Shop makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose.
              </Typography>
            </Paper>

            <Paper elevation={0} sx={{ p: 2, backgroundColor: theme.palette.grey[50] }}>
              <Typography variant="h5" sx={{ mb: 1, fontWeight: 'bold' }}>
                4. Limitations
              </Typography>
              <Typography>
                In no event shall NEXO Shop or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on NEXO Shop.
              </Typography>
            </Paper>

            <Paper elevation={0} sx={{ p: 2, backgroundColor: theme.palette.grey[50] }}>
              <Typography variant="h5" sx={{ mb: 1, fontWeight: 'bold' }}>
                5. Accuracy of Materials
              </Typography>
              <Typography>
                The materials appearing on NEXO Shop could include technical, typographical, or photographic errors. NEXO Shop does not warrant that any of the materials are accurate, complete, or current.
              </Typography>
            </Paper>

            <Paper elevation={0} sx={{ p: 2, backgroundColor: theme.palette.grey[50] }}>
              <Typography variant="h5" sx={{ mb: 1, fontWeight: 'bold' }}>
                6. Links
              </Typography>
              <Typography>
                NEXO Shop has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by NEXO Shop of the site. Use of any such linked website is at the user's own risk.
              </Typography>
            </Paper>

            <Paper elevation={0} sx={{ p: 2, backgroundColor: theme.palette.grey[50] }}>
              <Typography variant="h5" sx={{ mb: 1, fontWeight: 'bold' }}>
                7. Modifications
              </Typography>
              <Typography>
                NEXO Shop may revise these terms of use at any time without notice. By using this website, you are agreeing to be bound by the then current version of these terms of use.
              </Typography>
            </Paper>

            <Paper elevation={0} sx={{ p: 2, backgroundColor: theme.palette.grey[50] }}>
              <Typography variant="h5" sx={{ mb: 1, fontWeight: 'bold' }}>
                8. Governing Law
              </Typography>
              <Typography>
                These terms and conditions are governed by and construed in accordance with the laws of Pakistan, and you irrevocably submit to the exclusive jurisdiction of the courts in that location.
              </Typography>
            </Paper>

            <Typography variant="body2" sx={{ mt: 3, color: 'text.secondary' }}>
              Last Updated: {new Date().toLocaleDateString()}
            </Typography>
          </Stack>
        </Paper>
      </Container>
      <Footer />
    </Stack>
  )
}
